module.exports = __webpack_public_path__ + "static/media/map21.b9acb8ef.jpg";